import api from '@/api'
import { auth, authAll, goNewPage, logCount, toLogin, copy, getElementLoadingSvg } from '@/util'
import { sortChange } from './app'
import dayjs from 'dayjs'
import 'dayjs/locale/zh-cn'
import Cookies from 'js-cookie'
import hotkeys from 'hotkeys-js'
import mitt from 'mitt'

export default function globalProperties(app) {
    // 请求
    app.config.globalProperties.$api = api
    // 鉴权
    app.config.globalProperties.$auth = auth
    app.config.globalProperties.$authAll = authAll
    dayjs.locale('zh-cn')
    app.config.globalProperties.$copy = copy
    app.config.globalProperties.$elementLoadingSvg = getElementLoadingSvg()
    app.config.globalProperties.$dayjs = dayjs
    app.config.globalProperties.$cookies = Cookies
    app.config.globalProperties.$hotkeys = hotkeys
    app.config.globalProperties.$eventBus = mitt()

    app.config.globalProperties.$goNewPage = goNewPage
    app.config.globalProperties.$sortChange = sortChange
    app.config.globalProperties.$logCount = logCount
    app.config.globalProperties.$toLogin = toLogin
}
